import _slicedToArray from "/workspace/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { CubeTextureLoader } from 'three';
import { useLoader } from '@react-three/fiber';

function useCubeTexture(files, _ref) {
  var path = _ref.path;

  // @ts-ignore
  var _useLoader = useLoader( // @ts-ignore
  CubeTextureLoader, [files], function (loader) {
    return loader.setPath(path);
  }),
      _useLoader2 = _slicedToArray(_useLoader, 1),
      cubeTexture = _useLoader2[0];

  return cubeTexture;
}

useCubeTexture.preload = function (files, _ref2) {
  var path = _ref2.path;
  return useLoader.preload( // @ts-ignore
  CubeTextureLoader, [files], function (loader) {
    return loader.setPath(path);
  });
};

export { useCubeTexture };